<template>
<!--  <v-container fluid>-->
  <v-row dense class="mt-0">
    <v-col cols="1" class="mt-n1 mx-0">{{ legend }}</v-col>
    <v-col cols="11" class="mx-0 px-0">
      <v-progress-linear
          :color="getColor()"
          height="15"
          v-bind="$attrs"
          top
          :value="value"
      >
        <template v-slot:default="{ value }">
          <span class="text-caption">{{ value }}%</span>
        </template>
      </v-progress-linear>
    </v-col>
  </v-row>
<!--    </v-container>-->
</template>

<script>

export default {
  name: 'BatchRunProgressBar',
  props: ['legend', 'value', 'inverse'],

  methods: {
    getColor() {
      if (this.inverse == undefined) {
        if (this.value >= 100)
          return "blue lighten-1"
        if (this.value >= 90)
          return "green lighten-1"
        if (this.value >= 60)
          return "amber lighten-1"
        return "red lighten-1"
      }
      else {
        if (this.value >= 200)
          return "red lighten-1"
        if (this.value >= 120)
          return "amber lighten-1"
        if (this.value >= 80)
          return "green lighten-1"
        return "blue lighten-1"
      }
    }

  }
}

</script>


<style scoped lang="scss">
</style>